module.exports = {
	"id": "GR",
	"name": "Greece",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.168784,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.092064,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.007672,
			"22": 0.107408,
			"23": 0.015344,
			"24": null,
			"25": null,
			"26": 0.030688,
			"27": null,
			"28": null,
			"29": 0.015344,
			"30": 0.03836,
			"31": 0.061376,
			"32": 0.007672,
			"33": 0.015344,
			"34": 0.084392,
			"35": 0.046032,
			"36": 0.030688,
			"37": 0.023016,
			"38": 0.053704,
			"39": 0.084392,
			"40": 0.046032,
			"41": 0.015344,
			"42": 0.030688,
			"43": 0.130424,
			"44": 0.099736,
			"45": 0.046032,
			"46": 0.07672,
			"47": 0.15344,
			"48": 0.138096,
			"49": 5.754,
			"50": 0.145768,
			"51": 0.544712,
			"52": 0.360584,
			"53": 30.043552,
			"54": 8.009568,
			"55": 0.084392,
			"56": 0.023016,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": 0.099736,
			"5": 0.092064,
			"6": 0.092064,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.007672,
			"11": null,
			"12": 0.092064,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.015344,
			"17": 0.015344,
			"18": null,
			"19": null,
			"20": 0.007672,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": 0.007672,
			"26": null,
			"27": 0.023016,
			"28": null,
			"29": null,
			"30": 0.007672,
			"31": 0.015344,
			"32": 0.007672,
			"33": 0.023016,
			"34": 0.015344,
			"35": 0.015344,
			"36": 0.015344,
			"37": 0.023016,
			"38": 0.061376,
			"39": 0.03836,
			"40": 0.03836,
			"41": 0.03836,
			"42": 0.07672,
			"43": 0.15344,
			"44": 0.07672,
			"45": 0.138096,
			"46": 0.092064,
			"47": 0.61376,
			"48": 0.552384,
			"49": 14.062776,
			"50": 0.107408,
			"51": null,
			"52": 0.007672,
			"3.5": 0.015344,
			"3.6": 0.030688
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.245504,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.007672,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.007672,
			"35": null,
			"36": 0.07672,
			"37": 0.030688,
			"38": 0.053704,
			"39": 0.007672,
			"40": 0.590744,
			"41": 0.099736,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.023016,
			"12.1": 0.15344
		},
		"safari": {
			"0": null,
			"4": 0.015344,
			"5": 0.084392,
			"6": null,
			"7": 0.015344,
			"8": 0.046032,
			"9": 0.053704,
			"10": 0.5754,
			"3.1": null,
			"3.2": null,
			"5.1": 0.184128,
			"6.1": 0.030688,
			"7.1": 0.007672,
			"9.1": 0.283864
		},
		"ios_saf": {
			"8": 0,
			"10": 2.30595862781,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0621429167361,
			"8.1-8.4": 0.114806405495,
			"9.0-9.2": 0.0547700283097,
			"9.3": 0.835594021649
		},
		"android": {
			"3": 0,
			"4": 0.0429506976744,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0053688372093,
			"4.1": 0.154929302326,
			"4.2-4.3": 0.387323255814,
			"4.4": 0.888159069767,
			"4.4.3-4.4.4": 0.895828837209
		},
		"ie": {
			"6": 0.061376,
			"7": 0.122752,
			"8": 0.567728,
			"9": 0.3836,
			"10": 0.26852,
			"11": 3.636528,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0146095984675,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000405822179653
		},
		"edge": {
			"12": 0.069048,
			"13": 0.322224,
			"14": 1.097096
		},
		"ie_mob": {
			"10": 0.127613746479,
			"11": 0.519570253521
		},
		"bb": {
			"7": 0.011058,
			"10": null
		},
		"samsung": {
			"0": 1.992768
		},
		"and_uc": {
			"0": 0.15132
		},
		"op_mini": {
			"0": 0.196832579353
		},
		"and_chr": {
			"0": 15.817528
		},
		"and_ff": {
			"0": 0.020952
		}
	},
	"total": 96.98581
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/GR.json
 ** module id = 537
 ** module chunks = 0
 **/